import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import loginActions from "../login/duck/actions";

export default function useAuthWall() {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.user.isAuthenticated);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const showLoginModal = query.get("authwall") || false;
    const timer = parseInt(query.get("authwall_t")) || 2000;
    const isLoginDismissible = Boolean(query.get("authwall_ignore")) || false;
    if (!isLoggedIn && showLoginModal) {
      console.log({ showLoginModal, timer, isLoginDismissible });
      setTimeout(() => {
        dispatch(
          loginActions.showLoginModal(true, {
            isLoginDismissible: isLoginDismissible,
          })
        );
      }, timer);
    }
  }, []);
}
